export default "__VITE_ASSET__BQruCR4o__"